import React from 'react';

interface ModalContentTextProps {
  text: string;
  className?: string;
}

export default function ModalContentText({ text, className }: ModalContentTextProps) {
  return <p className={`text-sm text-gray-800 ${className}`}>{text}</p>;
}
